module.exports = __webpack_public_path__ + "media/images/map_icons-ad6c3c53733753931192a6581709707b.png";